import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import './styles/legacy-readability.css';
import { BrandLanguageProvider } from './components/brand/BrandLanguage';
const C1DecisionStudio = lazy(() => import('./pages/C1DecisionStudio'));
const V3Research = lazy(() => import('./pages/V3Research'));
const V3Results = lazy(() => import('./pages/V3Results'));
const Link01 = lazy(() => import('./pages/Link01'));
const RLModel = lazy(() => import('./pages/RLModel'));
const RobotLab = lazy(() => import('./pages/RobotLab'));
const BrandPages = lazy(() => import('./pages/BrandPages'));
const ClassicHome = lazy(() => import('./pages/ClassicHome'));
const OpalEditor = lazy(() => import('./components/WorkflowEditor/OpalEditor'));
const AICompanySimulator = lazy(() => import('./components/WorkflowEditor/AICompanySimulator'));
const WorkflowCreator = lazy(() => import('./components/WorkflowEditor/WorkflowCreator'));
const FullEditor = lazy(() => import('./components/WorkflowEditor/FullEditor'));
const SimpleEditor = lazy(() => import('./components/WorkflowEditor/SimpleEditor'));
const GenerativeAgentsEditor = lazy(() => import('./components/WorkflowEditor/GenerativeAgentsEditor'));
const SmallvilleSimulator = lazy(() => import('./components/WorkflowEditor/SmallvilleSimulator'));
const KakaoEmoticonSimulator = lazy(() => import('./components/WorkflowEditor/KakaoEmoticonSimulator'));
const CommentPickerSimulator = lazy(() => import('./components/WorkflowEditor/CommentPickerSimulator'));
const YouTubeTopicAnalyzer = lazy(() => import('./components/WorkflowEditor/YouTubeTopicAnalyzer'));
const YoutubeCalculatorEditor = lazy(() => import('./components/WorkflowEditor/YoutubeCalculatorEditor'));
const ChristmasCardEditor = lazy(() => import('./components/WorkflowEditor/ChristmasCardEditor'));
const ChristmasGallery = lazy(() => import('./pages/ChristmasGallery'));
const TribeExperiment = lazy(() => import('./pages/TribeExperiment'));
const ConnectLabLanding = lazy(() => import('./pages/ConnectLabLanding'));
const AgentMarketplace = lazy(() => import('./pages/AgentMarketplace'));
const Arena = lazy(() => import('./pages/Arena'));
const Plaza = lazy(() => import('./pages/Plaza'));
const Download = lazy(() => import('./pages/Download'));
const ConnectionDashboard = lazy(() => import('./components/ConnectionDashboard'));

// The original editor route remains a maintenance screen.
const MaintenancePage = () => <div className="legacy-maintenance">
  <p>EZERAI / EDITOR</p>
  <svg viewBox="0 0 240 160" fill="none" aria-hidden="true"><path d="M24 80H84M156 80H216" stroke="#d0f991"/><circle cx="120" cy="80" r="38" stroke="#d0f991"/><circle cx="120" cy="80" r="58" stroke="#d0f991" strokeDasharray="2 8"/><path d="M112 60 101 71v18l11 11m16-40 11 11v18l-11 11M108 80h24" stroke="#d0f991" strokeWidth="2"/></svg>
  <h1>테스트 중</h1><Link to="/tools">도구 모음 ↗</Link>
</div>;

function LocalConnection() {
  const { pathname: rawPathname } = useLocation();
  const pathname = rawPathname.replace(/\/+$/, '') || '/';
  return ['/', '/studio', '/models', '/research', '/research/v3', '/research/v3/results', '/robots/link-01', '/robots/link-01/playground', '/tools', '/about', '/download', '/connect-lab', '/tribe-experiment', '/login', '/signup'].includes(pathname) ? null : <ConnectionDashboard />;
}

function App() {
  return (
    <BrandLanguageProvider><BrowserRouter>
      {/* Local connection diagnostics remain on the existing tool routes. */}
      <Suspense fallback={<div role="status" style={{ padding: 48, color: "#e0e0e0" }}>Loading…</div>}>
      <LocalConnection />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/studio" element={<C1DecisionStudio />} />
        <Route path="/models" element={<BrandPages page="models" />} />
        <Route path="/models/rl" element={<RLModel />} />
        <Route path="/research" element={<BrandPages page="research" />} />
        <Route path="/research/v3" element={<V3Research />} />
        <Route path="/research/v3/results" element={<V3Results />} />
        <Route path="/robots/link-01" element={<Link01 />} />
        <Route path="/robots/link-01/playground" element={<RobotLab />} />
        <Route path="/tools" element={<BrandPages page="tools" />} />
        <Route path="/about" element={<BrandPages page="about" />} />
        <Route path="/classic" element={<ClassicHome />} />
        {/* 로그인·회원가입 제거 (2026-09-09). 옛 주소는 홈으로 보낸다. */}
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="/signup" element={<Navigate to="/" replace />} />
        <Route path="/editor" element={<MaintenancePage />} />
        <Route path="/editor-dev" element={<AICompanySimulator />} />
        <Route path="/editor-old" element={<OpalEditor />} />
        <Route path="/old-editor" element={<WorkflowCreator />} />
        <Route path="/example" element={<FullEditor />} />
        <Route path="/simple" element={<SimpleEditor />} />
        <Route path="/team-simulator" element={<GenerativeAgentsEditor />} />
        <Route path="/smallville" element={<SmallvilleSimulator />} />
        <Route path="/kakao-emoticon" element={<KakaoEmoticonSimulator />} />
        <Route path="/youtube-topic" element={<YouTubeTopicAnalyzer />} />
        <Route path="/comment-picker" element={<CommentPickerSimulator />} />
        {/* <Route path="/channel-analyzer" element={<ChannelAnalyzer />} /> */}
        <Route path="/youtube-calculator" element={<YoutubeCalculatorEditor />} />
        <Route path="/christmas-card" element={<ChristmasCardEditor />} />
        <Route path="/christmas-gallery" element={<ChristmasGallery />} />
        <Route path="/tribe-experiment" element={<TribeExperiment />} />
        <Route path="/connect-lab" element={<ConnectLabLanding />} />
        <Route path="/academy-admission" element={<AgentMarketplace />} />
        <Route path="/training" element={<AgentMarketplace />} />
        <Route path="/arena" element={<Arena />} />
        <Route path="/plaza" element={<Plaza />} />
        <Route path="/download" element={<Download />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </BrowserRouter></BrandLanguageProvider>
  );
}

export default App;
